export interface ApiRequestOptions<TBody = unknown> {
  query?: Record<string, unknown>
  body?: TBody
  headers?: Record<string, string>
}

export const useApi = () => {
  const { $api } = useNuxtApp()

  const get = <T>(url: string, requestOptions?: ApiRequestOptions) => {
    return $api<T>(url, {
      method: 'GET',
      query: requestOptions?.query,
      headers: requestOptions?.headers
    })
  }

  const post = <T, TBody = unknown>(url: string, requestOptions?: ApiRequestOptions<TBody>) => {
    return $api<T>(url, {
      method: 'POST',
      query: requestOptions?.query,
      body: requestOptions?.body as Record<string, unknown> | BodyInit | null | undefined,
      headers: requestOptions?.headers
    })
  }

  const put = <T, TBody = unknown>(url: string, requestOptions?: ApiRequestOptions<TBody>) => {
    return $api<T>(url, {
      method: 'PUT',
      query: requestOptions?.query,
      body: requestOptions?.body as Record<string, unknown> | BodyInit | null | undefined,
      headers: requestOptions?.headers
    })
  }

  const patch = <T, TBody = unknown>(url: string, requestOptions?: ApiRequestOptions<TBody>) => {
    return $api<T>(url, {
      method: 'PATCH',
      query: requestOptions?.query,
      body: requestOptions?.body as Record<string, unknown> | BodyInit | null | undefined,
      headers: requestOptions?.headers
    })
  }

  const del = <T>(url: string, requestOptions?: ApiRequestOptions) => {
    return $api<T>(url, {
      method: 'DELETE',
      query: requestOptions?.query,
      headers: requestOptions?.headers
    })
  }

  return { get, post, put, patch, del }
}
